import {getAll} from './common_requests'

interface TourReservationFilters {
  page: number
  limit: number
  status?: string
  dateFrom: string
  dateTo: string
  createdFrom: string
  createdTo: string
  search: string
  sortBy?: string
  sortDirection?: 'asc' | 'desc'
}

export const getTourReservations = async (filters: TourReservationFilters) => {
  return getAll(filters, '/tour-reservations')
} 